module.exports = __webpack_public_path__ + "img/0.231f1788.png";